import React, { Component } from 'react';
import { Route } from 'react-router';
import { Layout } from './components/Layout';
import { Home } from './components/Home';
import { FetchData } from './components/FetchData';

import { Counter } from './components/Counter';

import './custom.css'

export default class App extends Component {
    static displayName = App.name;

    constructor(props) {
        super(props);
        this.state = {
            key: 0,
            partnum: ''
        }
    }

    render() {

        let props = {};
        if (this.state.partnum) {
            props = {
                pc:null,
                filt: null,
                tags: null,
                parts: null,
                binding: null,
                data: this.props.data,
                cols: null,
                nocache: this.state.nocache,
                pn: this.state.partnum
            };
        } else
        {
            props = this.props;
        }

        return (
            <Layout>

                <FetchData key={this.state.key} {...props} root={true} reset={(pn) => this.incKey(pn) } />
                
            </Layout>
        );
    }

    incKey(pn) {
        this.setState((s) => {
            return { key: s.key + 1, partnum: pn };
        });
    }
}
